module.exports = __webpack_public_path__ + "img/SSLRSAT.609d8d8b.svg";